import type { EntityActionHandler } from '@/actions/entityActionRegistry';
import { registerEntityActions } from '@/actions/entityActionRegistry';

const placeholderModalHandler: EntityActionHandler = ({ openDialog, entity }, action) => {
  if (!openDialog) {
    throw new Error('placeholderModal handler requires dialog controls.');
  }

  openDialog('placeholder', {
    action,
    entity,
  });
};

const ieKitManageHandler: EntityActionHandler = ({ openDialog, entity }, action) => {
  if (!openDialog) {
    throw new Error('ieKit.manage handler requires dialog controls.');
  }

  const mode = action.id === 'ie-kit.create' ? 'create' : 'edit';
  if (mode === 'edit' && !entity) {
    throw new Error('ieKit.manage edit action requires an entity context.');
  }

  openDialog('ieKitEditor', {
    action,
    entity,
    mode,
  });
};

const ieKitAssignmentsHandler: EntityActionHandler = ({ openDialog, entity }, action) => {
  if (!openDialog) {
    throw new Error('ieKit.assignments handler requires dialog controls.');
  }
  if (!entity) {
    throw new Error('ieKit.assignments action requires an entity context.');
  }

  openDialog('kitAssignments', {
    action,
    entity,
  });
};

const ieKitInactivateHandler: EntityActionHandler = ({ openDialog, entity }, action) => {
  if (!openDialog) {
    throw new Error('ieKit.inactivate handler requires dialog controls.');
  }
  if (!entity) {
    throw new Error('ieKit.inactivate action requires an entity context.');
  }

  openDialog('ieKit.inactivate', {
    action,
    entity,
  });
};

const ieKitReactivateHandler: EntityActionHandler = ({ openDialog, entity }, action) => {
  if (!openDialog) {
    throw new Error('ieKit.reactivate handler requires dialog controls.');
  }
  if (!entity) {
    throw new Error('ieKit.reactivate action requires an entity context.');
  }

  openDialog('ieKit.reactivate', {
    action,
    entity,
  });
};

registerEntityActions({
  'ui.placeholderModal': placeholderModalHandler,
  'ieKit.manage': ieKitManageHandler,
  'ieKit.assignments': ieKitAssignmentsHandler,
  'ieKit.inactivate': ieKitInactivateHandler,
  'ieKit.reactivate': ieKitReactivateHandler,
});
